import React from 'react';
import { isAfter, startOfToday } from 'date-fns';

import { AdornedInput, Adornment, DatePicker, DatePickerInput, IconCalendarOutline } from '@zillow/constellation';

import type { Lease, Section } from '../../../../models/index';
import { LEASE_TERMS } from '../../../../constants';
import { DATE_PICKER_FORMAT, DATE_PICKER_PLACEHOLDER } from '../../../../constants/stringConstants';
import { disablePastDates } from '../../../../constants/functionConstants';
import { FULLSTORY_IGNORE_RAGE_CLICKS } from '../../../../constants/analytics';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  lease: Lease;
};

export default function LeaseTermsStartDate({ section, setSectionValues }: Props): JSX.Element {
  function onStartDateChange(date: Date): void {
    setSectionValues({
      [LEASE_TERMS.FIELD_NAME.START_DATE]: date,
      //Validates end date, do not delete
      [LEASE_TERMS.FIELD_NAME.END_DATE]: getEndDate(),
    });
    validateStartDate();
  }

  function validateStartDate(): void {
    const field = section.getField(LEASE_TERMS.FIELD_NAME.START_DATE);

    if (isAfter(startOfToday(), getStartDate())) {
      field.setErrorMessage(LEASE_TERMS.ERROR_MESSAGE.START_DATE_IN_PAST);
    }
  }

  function getStartDate(): string {
    return section.getFieldValue(LEASE_TERMS.FIELD_NAME.START_DATE);
  }

  function getEndDate(): string {
    return section.getFieldValue(LEASE_TERMS.FIELD_NAME.END_DATE);
  }

  return (
    <AdornedInput
      className={FULLSTORY_IGNORE_RAGE_CLICKS}
      input={
        <DatePickerInput
          placeholder={DATE_PICKER_PLACEHOLDER}
          value={getStartDate()}
          onChange={onStartDateChange}
          datepicker={<DatePicker dateFormat={DATE_PICKER_FORMAT} disabledDates={disablePastDates} />}
        />
      }
      rightAdornment={
        <Adornment>
          <IconCalendarOutline />
        </Adornment>
      }
    />
  );
}
